import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VForm,
    { ref: "form_rule" },
    [
      _c(
        VRow,
        { attrs: { justify: "center" } },
        [
          _c(
            VCol,
            { attrs: { cols: "3" } },
            [
              _c(VSubheader, { staticClass: "font-weight-bold" }, [
                _vm._v(
                  _vm._s(_vm.$t("data_quality.dataplex.rules.fields.name"))
                ),
              ]),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "9" } },
            [
              _c(VTextField, {
                attrs: {
                  dense: "",
                  outlined: "",
                  disabled: _vm.view,
                  rules: [
                    function (v) {
                      return !!v || _vm.$t("common.field_required")
                    },
                    function (v) {
                      return (
                        /^[A-Za-z0-9-]+$/.test(v || "") ||
                        "Solo letras, números o guiones"
                      )
                    },
                    function (v) {
                      return (
                        (v || "").match(/[A-Za-z0-9]$/) ||
                        "Debe terminar en letra o número"
                      )
                    },
                  ],
                  "hide-details": "auto",
                },
                model: {
                  value: _vm.rule.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.rule, "name", $$v)
                  },
                  expression: "rule.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { attrs: { justify: "center" } },
        [
          _c(
            VCol,
            { attrs: { cols: "3" } },
            [
              _c(VSubheader, { staticClass: "font-weight-bold" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("data_quality.dataplex.rules.fields.description")
                  )
                ),
              ]),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "9" } },
            [
              _c(VTextField, {
                attrs: {
                  dense: "",
                  outlined: "",
                  disabled: _vm.view,
                  rules: [
                    function (v) {
                      return !!v || _vm.$t("common.field_required")
                    },
                  ],
                  "hide-details": "auto",
                },
                model: {
                  value: _vm.rule.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.rule, "description", $$v)
                  },
                  expression: "rule.description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { attrs: { justify: "center" } },
        [
          _c(
            VCol,
            { attrs: { cols: "3" } },
            [
              _c(VSubheader, { staticClass: "font-weight-bold" }, [
                _vm._v(
                  _vm._s(_vm.$t("data_quality.dataplex.rules.fields.dimension"))
                ),
              ]),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "9" } },
            [
              _c(VSelect, {
                attrs: {
                  dense: "",
                  outlined: "",
                  disabled: _vm.view,
                  rules: [
                    function (v) {
                      return !!v || _vm.$t("common.field_required")
                    },
                  ],
                  items: _vm.dimensions,
                  "item-text": "text",
                  "item-value": "value",
                  "hide-details": "auto",
                },
                on: { change: _vm.onSelectDimension },
                model: {
                  value: _vm.rule.dimension,
                  callback: function ($$v) {
                    _vm.$set(_vm.rule, "dimension", $$v)
                  },
                  expression: "rule.dimension",
                },
              }),
              _c("label", { staticClass: "v-messages" }, [
                _vm._v(_vm._s(_vm.dimension ? _vm.dimension.description : "")),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { attrs: { justify: "center" } },
        [
          _c(
            VCol,
            { attrs: { cols: "3" } },
            [
              _c(VSubheader, { staticClass: "font-weight-bold" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("data_quality.dataplex.rules.fields.validation")
                  )
                ),
              ]),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "9" } },
            [
              _c(VSelect, {
                attrs: {
                  dense: "",
                  outlined: "",
                  disabled: _vm.view,
                  rules: [
                    function (v) {
                      return !!v || _vm.$t("common.field_required")
                    },
                  ],
                  items: _vm.expectations,
                  "item-text": "text",
                  "item-value": "value",
                  "hide-details": "auto",
                },
                on: { change: _vm.onSelectValidation },
                model: {
                  value: _vm.rule.expectation,
                  callback: function ($$v) {
                    _vm.$set(_vm.rule, "expectation", $$v)
                  },
                  expression: "rule.expectation",
                },
              }),
              _c("label", { staticClass: "v-messages" }, [
                _vm._v(
                  _vm._s(_vm.expectation ? _vm.expectation.description : "")
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.expectation.type_value == "text"
        ? _c(
            VRow,
            { attrs: { justify: "center" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("data_quality.dataplex.rules.fields.values")
                      )
                    ),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9" } },
                [
                  _c(VTextarea, {
                    attrs: {
                      disabled: _vm.view,
                      dense: "",
                      outlined: "",
                      rows: 2,
                      "hide-details": "auto",
                      hint: _vm.expectation.example,
                      "persistent-hint": "",
                    },
                    model: {
                      value: _vm.rule.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.rule, "value", $$v)
                      },
                      expression: "rule.value",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.expectation.type_value == "range_statistic"
        ? _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { cols: "3" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "data_quality.dataplex.rules.fields.range_statistic"
                        )
                      )
                    ),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "6" } },
                [
                  _c(VSelect, {
                    attrs: {
                      disabled: _vm.view,
                      dense: "",
                      outlined: "",
                      items: _vm.statistic_values,
                      "hide-details": "auto",
                    },
                    model: {
                      value: _vm.rule.statistic_value,
                      callback: function ($$v) {
                        _vm.$set(_vm.rule, "statistic_value", $$v)
                      },
                      expression: "rule.statistic_value",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.expectation.type_value == "range" ||
      _vm.expectation.type_value == "range_statistic"
        ? _c(
            VRow,
            { attrs: { justify: "center" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("data_quality.dataplex.rules.fields.min") + " >="
                      )
                    ),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3" } },
                [
                  _c(VTextField, {
                    attrs: {
                      disabled: _vm.view,
                      dense: "",
                      outlined: "",
                      type: "number",
                      "hide-details": "auto",
                    },
                    model: {
                      value: _vm.rule.min_value,
                      callback: function ($$v) {
                        _vm.$set(_vm.rule, "min_value", $$v)
                      },
                      expression: "rule.min_value",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("data_quality.dataplex.rules.fields.strict") +
                          ' ">"'
                      )
                    ),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3" } },
                [
                  _c(VSwitch, {
                    attrs: {
                      disabled: _vm.view,
                      dense: "",
                      outlined: "",
                      "hide-details": "auto",
                    },
                    model: {
                      value: _vm.rule.min_value_strict,
                      callback: function ($$v) {
                        _vm.$set(_vm.rule, "min_value_strict", $$v)
                      },
                      expression: "rule.min_value_strict",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.expectation.type_value == "range" ||
      _vm.expectation.type_value == "range_statistic"
        ? _c(
            VRow,
            { attrs: { justify: "center" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("data_quality.dataplex.rules.fields.max") + " <="
                      )
                    ),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3" } },
                [
                  _c(VTextField, {
                    attrs: {
                      disabled: _vm.view,
                      dense: "",
                      outlined: "",
                      type: "number",
                      "hide-details": "auto",
                    },
                    model: {
                      value: _vm.rule.max_value,
                      callback: function ($$v) {
                        _vm.$set(_vm.rule, "max_value", $$v)
                      },
                      expression: "rule.max_value",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("data_quality.dataplex.rules.fields.strict") +
                          ' "<"'
                      )
                    ),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3" } },
                [
                  _c(VSwitch, {
                    attrs: {
                      disabled: _vm.view,
                      dense: "",
                      outlined: "",
                      "hide-details": "auto",
                    },
                    model: {
                      value: _vm.rule.max_value_strict,
                      callback: function ($$v) {
                        _vm.$set(_vm.rule, "max_value_strict", $$v)
                      },
                      expression: "rule.max_value_strict",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.expectation.type_value == "set"
        ? _c(
            VRow,
            { attrs: { justify: "center" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("data_quality.dataplex.rules.fields.values")
                      )
                    ),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9" } },
                [
                  _c(VCombobox, {
                    attrs: {
                      multiple: "",
                      dense: "",
                      outlined: "",
                      chips: "",
                      "append-icon": "",
                      disabled: _vm.view,
                      "hide-details": "auto",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "selection",
                          fn: function (ref) {
                            var item = ref.item
                            var attrs = ref.attrs
                            var selected = ref.selected
                            var disabled = ref.disabled
                            var parent = ref.parent
                            return [
                              _c(
                                VChip,
                                _vm._b(
                                  {
                                    key: JSON.stringify(item),
                                    attrs: {
                                      "input-value": selected,
                                      disabled: disabled,
                                      dark: "",
                                    },
                                    on: {
                                      "click:close": function ($event) {
                                        return parent.selectItem(item)
                                      },
                                    },
                                  },
                                  "v-chip",
                                  attrs,
                                  false
                                ),
                                [_vm._v(_vm._s(item))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3076449977
                    ),
                    model: {
                      value: _vm.rule.set_value,
                      callback: function ($$v) {
                        _vm.$set(_vm.rule, "set_value", $$v)
                      },
                      expression: "rule.set_value",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        VRow,
        { attrs: { justify: "center" } },
        [
          [
            "range_expectation",
            "regex_expectation",
            "set_expectation",
            "uniqueness_expectation",
          ].indexOf(_vm.rule.expectation) != -1
            ? _c(
                VCol,
                { attrs: { cols: "6" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("data_quality.dataplex.rules.fields.ignore_null")
                      )
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          [
            "range_expectation",
            "regex_expectation",
            "set_expectation",
            "uniqueness_expectation",
          ].indexOf(_vm.rule.expectation) != -1
            ? _c(
                VCol,
                { attrs: { cols: "6" } },
                [
                  _c(VSwitch, {
                    attrs: {
                      disabled: _vm.view,
                      dense: "",
                      outlined: "",
                      "hide-details": "auto",
                    },
                    model: {
                      value: _vm.rule.ignore_null,
                      callback: function ($$v) {
                        _vm.$set(_vm.rule, "ignore_null", $$v)
                      },
                      expression: "rule.ignore_null",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          [
            "range_expectation",
            "non_null_expectation",
            "set_expectation",
            "regex_expectation",
            "uniqueness_expectation",
            "row_condition_expectation",
          ].indexOf(_vm.rule.expectation) != -1
            ? _c(
                VCol,
                { attrs: { cols: "6" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("data_quality.dataplex.rules.fields.threashold")
                      )
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          [
            "range_expectation",
            "non_null_expectation",
            "set_expectation",
            "regex_expectation",
            "uniqueness_expectation",
            "row_condition_expectation",
          ].indexOf(_vm.rule.expectation) != -1
            ? _c(
                VCol,
                { attrs: { cols: "6" } },
                [
                  _c(VTextField, {
                    attrs: {
                      disabled: _vm.view,
                      dense: "",
                      outlined: "",
                      type: "number",
                      "hide-details": "auto",
                    },
                    model: {
                      value: _vm.rule.threshold,
                      callback: function ($$v) {
                        _vm.$set(_vm.rule, "threshold", $$v)
                      },
                      expression: "rule.threshold",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }